// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import O1HD from "../../../../../engines/gameEngine";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import { LotteryKind } from "./data/LotteryKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LotteryBaseLayer extends BasePopUpLayer {

    @property({ type: cc.Node, displayName:'' })
	nodeVideo: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGold: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelGold: cc.Label = null;

    @property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

    @property(cc.Node)
    touchNode : cc.Node = null;
    @property(cc.Node)
    maskNode : cc.Node = null;
    @property(cc.Prefab)
    nodeItemPrefab : cc.Prefab = null;

    protected bFinishShow = false;

    // onLoad () {}

    start () {
        this.initTouchEvent(this.touchNode);
        this.refreshState();
        this.showPrice();

        O1HD.getModules().uiControlModule.hideLoading();
    }

    // update (dt) {}

    resetData() {
        this.bFinishShow = false;
        this.maskNode.active = true;
        let graphicsNode = this.getGraphicsNode();
        graphicsNode.clear();
    }

    showPrice() {
        let lotteryInfo = this.getLotteryInfo();
        let strPrice = data_control.getNumberFormat(lotteryInfo.price);
        this.labelGold && (this.labelGold.string = strPrice);
        this.labelPrice && (this.labelPrice.string = '面值' + strPrice);
    }
    
    refreshState() {
        let lotteryInfo = this.getLotteryInfo();

        let gameData = NormalGameManager._instance.getGameData();
        let count = gameData.curLotteryNum[lotteryInfo.idx] || 0;
        let bShowVideo = count >= lotteryInfo.limitCount;
        this.nodeVideo.active = bShowVideo;
        this.nodeGold.active = !bShowVideo;
        this.labelGold.node.active = !bShowVideo;
    }

    getLotteryInfo() {
        let lotteryInfo: LotteryKind.LotteryItemInfo = this._carryData.lotteryInfo;
        return lotteryInfo;
    }

    getMaksNode() {
        let maskNode = this.maskNode.getComponent(cc.Mask);
        return maskNode;
    }

    getGraphicsNode() {
        let maskNode = this.getMaksNode();
        let graphicsNode: cc.Graphics = maskNode['_graphics'];
        return graphicsNode;
    }

    touchEventMove(event: cc.Event.EventTouch){
        if (!this.maskNode.active) {
            return;
        }

        let circleLen = LotteryKind.GeneralValue.EVERY_CIRCLE_ADJUST;
        let touches = event.getTouches();
        if ( touches.length > 1 ) {
            //多点触控
            let point1Pos = touches[0].getLocation().clone();
            let point2Pos = touches[1].getLocation().clone();
            let previousPos1 = touches[0].getPreviousLocation().clone();
            let previousPos2 = touches[1].getPreviousLocation().clone();
            let addWid = LotteryKind.GeneralValue.MULTI_TOUCH_LINE;
            let addWid2 = LotteryKind.GeneralValue.MULTI_TOUCH_LINE;

            if (point1Pos.x > point2Pos.x) {
                point1Pos.x += addWid;
                point2Pos.x -= addWid;

                previousPos1.x += addWid;
                previousPos2.x -= addWid;
            } else {
                point1Pos.x -= addWid;
                point2Pos.x += addWid;

                previousPos1.x -= addWid;
                previousPos2.x += addWid;

            }

            if (previousPos1.y > point1Pos.y) {
                previousPos1.y += addWid2;
                point1Pos.y -= addWid2;
            } else {
                previousPos1.y -= addWid2;
                point1Pos.y += addWid2;
            }
            if (previousPos2.y > point2Pos.y) {
                previousPos2.y += addWid2;
                point2Pos.y -= addWid2;
            } else {
                previousPos2.y -= addWid2;
                point2Pos.y += addWid2;
            }

            let delta0 = previousPos1.sub( point1Pos );
            let delta1 = previousPos2.sub( point2Pos );
            
            if ( Math.abs(delta0.y) > circleLen || Math.abs(delta1.y) > circleLen ) {
                let needAddY = Math.max(Math.abs(delta0.y), Math.abs(delta1.y))
                let needAddCount = Math.floor( needAddY / circleLen );
                let j = 1;
                for ( let i = 1 ; i <= needAddY ; i += circleLen ) {
                    let pointPos1Temp = point1Pos.add( delta0.div(needAddCount).mul( j ) );
                    let pointPos2Temp = point2Pos.add( delta1.div(needAddCount).mul( j ) );
                    this.addLine( 
                        this.maskNode.convertToNodeSpaceAR( pointPos1Temp ) 
                        , this.maskNode.convertToNodeSpaceAR( pointPos2Temp )
                    );
                    this.checkJudge(pointPos1Temp , pointPos2Temp);
                    j ++;
                }
            }
            this.addLine( 
                this.maskNode.convertToNodeSpaceAR( point1Pos ) 
                , this.maskNode.convertToNodeSpaceAR( point2Pos )
            );
            this.checkJudge(point1Pos ,point2Pos );
        }else{

            let location = event.getLocation().clone();
            let previous = event.getPreviousLocation().clone();
            //单点操作
            let distance = Math.abs( Math.floor( location.sub( previous ).mag() ) );
            if ( distance > circleLen ) {
                //补点操作
                for ( let num = 0 ; num < distance ; num += circleLen ) {
                    let subLocation : cc.Vec2 = location.sub(previous);
                    let actualLocation = previous.add( subLocation.div( distance ).mul( num ) );
                    this.addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                    this.checkJudgeNode(actualLocation);
                }
            }
            this.addCircle( this.maskNode.convertToNodeSpaceAR(location) );
            this.checkJudgeNode(location);
        }
    }

    checkJudge(pos1: cc.Vec2, pos2: cc.Vec2) {

    }

    checkJudgeNode(pos: cc.Vec2) {

    }

    addCircle(pos:cc.Vec2){
        let circleSize = LotteryKind.GeneralValue.SINGLE_TOUCH_CIRCLE;
        let graphicsNode = this.getGraphicsNode();
        graphicsNode.circle (pos.x,pos.y, circleSize );
        graphicsNode.fill();
        graphicsNode.stroke();
    }

    addLine( pos1:cc.Vec2 , pos2 : cc.Vec2 ){
        let graphics = this.getGraphicsNode();
        graphics.lineWidth = LotteryKind.GeneralValue.MULTI_TOUCH_LINE;
        graphics.lineCap = cc.Graphics.LineCap.ROUND;
        graphics.strokeColor = cc.color( 20,20,20 );
        graphics.moveTo( pos1.x , pos1.y );
        graphics.lineTo( pos2.x , pos2.y );
        graphics.stroke();
    }

    showAllMask() {
        this.maskNode.active = false;
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    /**
     * 购买
     */
    onClickBuy(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (this.nodeVideo.active) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.resetStartLottery();
                this.resetData();
                
            },()=>{
                O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
            },()=>{
    
            },"观看视频获得刮刮乐次数");
        } else {
            let lotteryInfo = this.getLotteryInfo();
            let needPayPrice : number = lotteryInfo.price;
            if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
                O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
                
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
            this.resetStartLottery();
            let gameData = NormalGameManager._instance.getGameData();
            gameData.curLotteryNum[lotteryInfo.idx] = gameData.curLotteryNum[lotteryInfo.idx] || 0;
            gameData.curLotteryNum[lotteryInfo.idx]++;
            NormalGameManager._instance.writeGameData();
            this.refreshState();
            this.resetData();

            O1HD.emit(MessageEventKind.EventName.UPDATE_LOTTERY_LIST);
        } 
    }

    resetStartLottery() {
        
    }
}
